import React from "react";

function ExploreAppsTop() {
  return (
    <div className="container text-center" style={{ marginTop: "6rem" }}>
      <div>
        <label className="display-5 fw-bold">All Shivapdf tools</label>
      </div>
      <div className=" mt-4">
        <label className="fs-5">
          Explore all pdf editing tools. Make your workflow streamline using our
          free to use pdf editing tools.
        </label>
      </div>
      <div className="d-flex  justify-content-center align-items-center mt-3">
        {/* Works offline */}
        <div className="d-flex justify-content-center align-items-center">
          {/* Image */}
          <img
            loading="lazy"
            src="./images/circle-fill.svg"
            alt="circle"
            style={{
              filter:
                "brightness(0) saturate(100%) invert(60%) sepia(63%) saturate(6138%) hue-rotate(165deg) brightness(99%) contrast(102%)",
              width: "16px",
              height: "auto",
              maxWidth: "16px",
            }}
          ></img>
          <label className="text-muted ms-2">Works Offline (Locally)</label>
        </div>
        {/* Works Online */}
        <div className="d-flex justify-content-center align-items-center ms-3">
          {/* Image */}
          <img
            loading="lazy"
            src="./images/circle-fill.svg"
            alt="circle"
            style={{
              filter:
                "invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)",
              width: "16px",
              height: "auto",
              maxWidth: "16px",
            }}
          ></img>
          <label className="text-muted ms-2">Works Online</label>
        </div>
      </div>
    </div>
  );
}

export default ExploreAppsTop;
